import LOCALES from "../../../constants/locales.constants";

const locale = localStorage.getItem("locales") || "rs";

export const expirationOptions = [
  {
    id: 1,
    name:LOCALES[localStorage.getItem("locales") || "rs"]["monthly"], // Mesečni / Monthly
    value: "month"
  },
  {
    id: 2,
    name: LOCALES[localStorage.getItem("locales") || "rs"]["one_time"], // Jednokratni / One-time
    value: "one_time"
  },
  {
    id: 3,
    name: LOCALES[localStorage.getItem("locales") || "rs"]["voucher"], // Vaučer / Voucher
    value: "voucher"
  }
];
